/**
 * LeaveCalendarPage — Csapat szabadság naptár oldal (vezető nézet)
 */

import { useTranslation } from '@kgc/i18n';
import { Button } from '@kgc/ui';
import { useState } from 'react';
import { LeaveCalendarView } from '../components/LeaveCalendarView';
import { useLeaveCalendar } from '../hooks/useLeaveCalendar';

export function LeaveCalendarPage() {
  const { t } = useTranslation();
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth() + 1);

  const { data: requests = [], isLoading } = useLeaveCalendar(year, month);

  const prevMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear(y => y - 1);
    } else {
      setMonth(m => m - 1);
    }
  };

  const nextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear(y => y + 1);
    } else {
      setMonth(m => m + 1);
    }
  };

  const monthLabel = new Date(year, month - 1, 1).toLocaleDateString('hu-HU', {
    year: 'numeric',
    month: 'long',
  });

  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">{t('hr.leave.calendar')}</h1>

      <div className="flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={prevMonth}>
          ←
        </Button>
        <span className="text-lg font-medium min-w-[160px] text-center">{monthLabel}</span>
        <Button variant="outline" size="sm" onClick={nextMonth}>
          →
        </Button>
      </div>

      {isLoading ? (
        <p className="text-muted-foreground">{t('common.loading')}</p>
      ) : (
        <LeaveCalendarView year={year} month={month} requests={requests} />
      )}
    </div>
  );
}
